import { FormControl, FormGroup } from '@angular/forms';

/** Signature requirement codes persisted on the Service step (S4: RES / ZS50). */
export const SIGNATURE_REQUIREMENT_NONE = 'none' as const;
export const SIGNATURE_REQUIREMENT_RES = 'RES' as const;
export const SIGNATURE_REQUIREMENT_ZS50 = 'ZS50' as const;

export type SignatureRequirement =
  | typeof SIGNATURE_REQUIREMENT_NONE
  | typeof SIGNATURE_REQUIREMENT_RES
  | typeof SIGNATURE_REQUIREMENT_ZS50;

/** Form value for signature protection selection. */
export interface SignatureProtectionFormValue {
  requirement: SignatureRequirement;
}

/** Persisted signature protection payload for the Service step. */
export interface SignatureProtectionSavePayload {
  requirement: SignatureRequirement;
}

/**
 * Creates the Signature Protection reactive form with Figma default (none).
 */
export function createSignatureProtectionForm(
  initial?: Partial<SignatureProtectionFormValue>,
): FormGroup<{
  requirement: FormControl<SignatureRequirement>;
}> {
  return new FormGroup({
    requirement: new FormControl<SignatureRequirement>(
      initial?.requirement ?? SIGNATURE_REQUIREMENT_NONE,
      { nonNullable: true },
    ),
  });
}

/**
 * Returns whether the Signature Protection form is currently valid.
 * Always valid for v1 (optional selection with a default).
 */
export function isSignatureProtectionValid(
  form: FormGroup<{
    requirement: FormControl<SignatureRequirement>;
  }>,
): boolean {
  return form.valid;
}

/**
 * Builds the persistable signature protection payload from the form.
 */
export function buildSignatureProtectionSavePayload(
  form: FormGroup<{
    requirement: FormControl<SignatureRequirement>;
  }>,
): SignatureProtectionSavePayload {
  return {
    requirement: form.controls.requirement.value,
  };
}
